export default __webpack_public_path__ + "static/events-dark-0f315e44af9ec0edda47933ebdb2a136.png";